import { Button } from '@lms/ui/button';
import { cn } from '@lms/ui/utils';
import { Loader2 } from 'lucide-react';

// In the Next app this read `useFormStatus()`. The SPA calls async functions
// directly, so callers pass the pending state explicitly.
const SubmitButton = ({
  label,
  pending,
  disabled,
  className,
}: {
  label: string;
  pending?: boolean;
  disabled?: boolean;
  className?: string;
}) => {
  return (
    <Button
      disabled={pending || disabled === true}
      type="submit"
      className={cn('w-full', className)}
    >
      {pending ? <Loader2 className="animate-spin" /> : label}
    </Button>
  );
};

SubmitButton.displayName = 'SubmitButton';

export { SubmitButton };
